class ProductCard extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const linkurl = document.querySelectorAll('.linkurl');
        linkurl.forEach(card => {
            const url = card.parentElement.querySelector('.produrl').getAttribute('href');
            card.addEventListener('click', (event) => {
                event.preventDefault();
                window.location.href = url;
            });
            card.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    window.location.href = url;
                }
            });
        });
    }
}

customElements.define('product-card', ProductCard)